import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PackPackingOrderStepListMobileComponent } from './components-mobile/pack-packing-order-step-list-mobile/pack-packing-order-step-list-mobile.component';
import { PackingOrderListMobileComponent } from './components-mobile/packing-order-list-mobile/packing-order-list-mobile.component';
import { PackingPorderListMobileComponent } from './components-mobile/packing-porder-list-mobile/packing-porder-list-mobile.component';
import { PackingOrderListComponent } from './components/packing-order-list/packing-order-list.component';


const routes: Routes = [
  { path: 'packing-order',                            component: PackingOrderListComponent        },
  { path: 'packing-order-mobile',                     component: PackingOrderListMobileComponent  },
  { path: 'packing-pack-packing-order-step-mobile',   component: PackPackingOrderStepListMobileComponent  },
  { path: 'packing-warehouse-transfer-expedition',    component: PackingPorderListMobileComponent  },
  { path: 'packing-warehouse-transfer-reception',     component: PackingPorderListMobileComponent  },
  
]


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssabilPackingRoutingModule { }
